export default __webpack_public_path__ + "static/media/log-out.47186440.svg";